export const setProgress = (state, payload) => {
  state.progress = payload;
}

export const setVisibility = (state, payload) => {
  state.visible = payload;
}
